import { render, staticRenderFns } from "./SelectAddress.vue?vue&type=template&id=a4a074a6&scoped=true&"
import script from "./SelectAddress.vue?vue&type=script&lang=js&"
export * from "./SelectAddress.vue?vue&type=script&lang=js&"
import style0 from "./SelectAddress.vue?vue&type=style&index=0&id=a4a074a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a074a6",
  null
  
)

export default component.exports